// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhg_wv bhg_iz bhg_xj bhg_i bhg_j bhg_q bhg_vr bhg_er bhg_sm bhg_sn bhg_eb","CommentsButton__icon":"il_b bhg_rx"};